































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class BaseView extends Vue {
  store = this.$store.direct;

  @Prop()
  title!: string;
  @Prop()
  subtitle!: string;
  @Prop()
  info!: string;

  get welcome() {
    return this.store.state.session.welcome;
  }

  closeWelcome() {
    this.store.commit.session.SET_WELCOME(false);
  }
}
